import './index.styl';
import React, { Component } from 'react';
import PropTypes from '@ali/prop-types';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));
import { Router } from '@ali/react-router-lite';
import getConfig from '@ali/cuttle-config'
import IntlProvider from '@ali/brokkoli/lib/IntlProvider';
import Loading from '@ali/broccoli-cmp-loading';
import log from '@ali/log';
import ua from '@ali/simple-ua';
import '@ali/fit';
import * as logBus from '@ali/log-bus';

import NonUser from '@ali/broccoli-cmp-nonuser';
const { callRightNow, appType, isInBlackListFromClient } = require('@ali/bucket/components/app_link');
import getLocale from '@ali/brokkoli/lib/utils/get_locale';

import PageIndex from './page_index';
import PageResult from './page_result';
import PageAnswer from './page_answer';
import { init } from './actions/init.js';

class Index extends Component {

  static defaultProps = {
    commonConfig: getConfig('commonConfig'),
    pageNonuser: getConfig('pageNonuser'),
    pageLoading: getConfig('pageLoading'),
    pageIndex: getConfig('pageIndex'),
    pageAnswer: getConfig('pageAnswer'),
    pageResult: getConfig('pageResult'),
  };

  constructor(props) {
    super(props);
    this.state = {};
    store.dispatch(init(props));
    document.title = getLocale('title.title');
    logBus.newsDAU({
      isNewsAct: true,
      isBrowserAct: true,
      na: props.type,
      lang: getLocale('liveness.language'),
    });
    const reg = /app\/(\w+)/
    const result = reg.exec(location.href)
    const appId = result && result[1] || 'quiz_game'
    log.setup({
      intl: true,
      type: props.commonConfig.type,
      prefix: props.commonConfig.prefix,
      app_key: appId,
      actname: appId,
    });
    log.baseParam('acturl', window.location.href);
    // 进入非目标环境,页面尝试唤起
    if (ua.pf !== 'UC' && ua.pf !== 'UC_MINI' && ua.pf !== 'UCNEWS' && !isInBlackListFromClient()) {
      callRightNow({
        appType: appType.UC_BROWSER_INTL,
      });
    }
  }

  _renderAct() {
    const { env } = store.getState().init;
    const {
      loadingNum,
      loadingBackgroundColor,
      loadingColor,
      frameArr,
      ratio,
    } = this.props.pageLoading;
    const {
      bgTitle,
      browserBtn,
      newsBtn,
    } = this.props.pageNonuser;
    const { imgCdnPrefix } = this.props.commonConfig;
    return (
      <Provider store={store}>
        <IntlProvider>
          <Loading
            // debug={true}
            strLoad={'loading.text'}
            img= {`${imgCdnPrefix}loading.png`}
            num={loadingNum}
            colorFont={loadingColor}
            colorBg={loadingBackgroundColor}
            frameArr={frameArr}
            ratio={ratio}
            srcs={[
              getLocale('page_index.page_bg'),
              // 'http://img.ucweb.com/s/uae/g/0n/guanjunshiwole0518.png',
              // 'http://img.ucweb.com/s/uae/g/0n/ipl420180517en.png',
            ]}>
              <div>
                <Router mode="hash" defaultRoute="index">
                  <PageIndex name="index" />
                  <PageResult name="result" />
                  <PageAnswer name="answer" />
                </Router>


                {this.props.children}
                <NonUser
                  isUser={env === 1}
                  width={500}
                  bgTitle={bgTitle}
                  browserBtn={browserBtn}
                  // newsBtn={newsBtn}
                  title={'nonuser.title'}
                  content={'nonuser.desc'}
                  downloadUcBrowser={'nonuser.link_ucbrowser'}
                  // downloadUcNews={'nonuser.link_ucnews'}
                  >
                </NonUser>
              </div>
          </Loading>
        </IntlProvider>
      </Provider>
    );
  }

  // 不兼容页
  // _renderNonSupport() {
  //   const { NonSupport } = this.state;
  //   const getNonSupport = mod => {
  //     this.setState({ NonSupport: mod.default });
  //   };
  //   if (!NonSupport) {
  //     import('@ali/broccoli-cmp-nonsupport').then(getNonSupport);
  //     return null;
  //   }
  //   return <NonSupport
  //     colorTitle={'#401800'}
  //     colorDesc={'#fff'}
  //     colorBtn={'#ffffff'}
  //     colorBgBtn={'#40c5f4'}
  //   />;
  // }

  // 活动结束页
  _renderActEnd() {
    const { ActEnd } = this.state;
    const getActEnd = mod => {
      this.setState({ ActEnd: mod.default });
    };
    if (!ActEnd) {
      import('@ali/broccoli-cmp-actend').then(getActEnd);
      return null;
    }
    return <ActEnd
      colorTitle={'#fff'}
      colorDesc={'#401800'}
      linkRule={this.props.rule}
      shanreScene={'shareright'}
      btnPending={'#40c5f4'}
    />;
  }

  componentDidMount() {
    // log.logVisit('pg');
  }

  render() {
    const { actState } = store.getState().init;
    // if (env === -1) return this._renderNonSupport();
    if (actState === 0) return this._renderActEnd();
    return this._renderAct();
    // return <div>hello world</div>;
  }
}

export default Index;
